var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:_vm.uniqueCanvasId + _vm.renderingKey,staticClass:"hand-cursor",attrs:{"width":_vm.canvasWidth,"height":_vm.canvasHeight},on:{"click":_vm.canvasClicked}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2edf494","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Grid.vue
// module id = null
// module chunks = 